export default __webpack_public_path__ + "static/media/MowiBusinessWhite.8cd0bb98.png";